module.exports = __webpack_public_path__ + "static/media/technical_intro_bitcoin_bitcoin-studio.d5856f90.jpg";